import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import API from '../../lib/api';
import DatePicker from '../form-elements/datePicker';
import { formateDate, getUid } from '../../utils/helper';
import NewsDetail from './newsDetail';
import strikersLogo from '../../assets/images/logo.png';
import './news.scss';
import { getDomainLogo } from '../../constants/domainConfig';

const NEWS_ARTICLE_STORAGE = 'strikers_news_article';

class NewsList extends Component {
    constructor(props) {
        super(props);
        const today = new Date().toISOString().slice(0, 10);
        this.state = {
            tab: 'latest',
            leagues: [],
            teams: [],
            leagueId: '',
            teamId: '',
            newsDate: today,
            articles: [],
            videos: [],
            activeVideo: null,
            loading: true,
            loadingVideos: false,
            loadingLeagues: true,
            loadingTeams: false,
            configured: true,
            message: '',
            error: '',
            videosError: '',
        };
    }

    componentDidMount() {
        this.loadLeagues();
        this.loadLatest();
    }

    loadLeagues = () => {
        this.setState({ loadingLeagues: true });
        API.getFootballNewsLeagues()
            .then((data) => {
                this.setState({
                    loadingLeagues: false,
                    configured: data.configured !== false,
                    message: data.message || '',
                    leagues: Array.isArray(data.leagues) ? data.leagues : [],
                });
            })
            .catch(() => {
                this.setState({ loadingLeagues: false });
            });
    };

    loadLatest = () => {
        const { newsDate } = this.state;
        this.setState({ loading: true, error: '' });
        API.getNewsLatest(newsDate)
            .then((data) => {
                this.setState({
                    loading: false,
                    articles: (data && data.articles) || [],
                    configured: data.configured !== false,
                    message: data.message || '',
                    error: data.error || '',
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    articles: [],
                    error: 'failed',
                });
            });
    };

    loadByLeague = (leagueId) => {
        if (!leagueId) return;
        this.setState({ loading: true, error: '', leagueId });
        API.getFootballNewsByLeague(leagueId)
            .then((data) => {
                this.setState({
                    loading: false,
                    articles: (data && data.articles) || [],
                    configured: data.configured !== false,
                    error: data.error || '',
                });
            })
            .catch(() => {
                this.setState({ loading: false, articles: [], error: 'failed' });
            });
    };

    loadTeamsForLeague = (leagueId) => {
        if (!leagueId) {
            this.setState({ teams: [], teamId: '', loadingTeams: false });
            return;
        }
        this.setState({ loadingTeams: true, teamId: '', teams: [] });
        API.getFootballNewsTeams(leagueId)
            .then((data) => {
                this.setState({
                    loadingTeams: false,
                    teams: Array.isArray(data.teams) ? data.teams : [],
                });
            })
            .catch(() => {
                this.setState({ loadingTeams: false, teams: [] });
            });
    };

    loadByTeam = (teamId) => {
        if (!teamId) return;
        this.setState({ loading: true, error: '', teamId });
        API.getFootballNewsByTeam(teamId)
            .then((data) => {
                this.setState({
                    loading: false,
                    articles: (data && data.articles) || [],
                    configured: data.configured !== false,
                    error: data.error || '',
                });
            })
            .catch(() => {
                this.setState({ loading: false, articles: [], error: 'failed' });
            });
    };

    loadVideos = () => {
        this.setState({ loadingVideos: true, videosError: '', message: '' });
        API.getNewsVideos()
            .then((data) => {
                this.setState({
                    loadingVideos: false,
                    videos: (data && data.videos) || [],
                    configured: data.configured !== false,
                    message: data.message || '',
                    videosError: data.error || '',
                });
            })
            .catch(() => {
                this.setState({
                    loadingVideos: false,
                    videos: [],
                    videosError: 'failed',
                });
            });
    };

    setTab = (tab) => {
        this.setState({ tab, error: '', articles: [], videosError: '' }, () => {
            if (tab === 'latest') {
                this.loadLatest();
            }
            if (tab === 'videos') {
                this.loadVideos();
            }
        });
    };

    onLeagueChangeLeagueTab = (e) => {
        const leagueId = e.target.value;
        this.setState({ leagueId });
        if (leagueId) {
            this.loadByLeague(leagueId);
        } else {
            this.setState({ articles: [] });
        }
    };

    onLeagueChangeTeamTab = (e) => {
        const leagueId = e.target.value;
        this.setState({ leagueId, articles: [] });
        if (leagueId) {
            this.loadTeamsForLeague(leagueId);
        } else {
            this.setState({ teams: [], teamId: '' });
        }
    };

    onTeamChange = (e) => {
        const teamId = e.target.value;
        this.setState({ teamId });
        if (teamId) {
            this.loadByTeam(teamId);
        } else {
            this.setState({ articles: [] });
        }
    };

    onNewsDatePicked = (day) => {
        if (!day) return;
        const y = day.getFullYear();
        const m = String(day.getMonth() + 1).padStart(2, '0');
        const d = String(day.getDate()).padStart(2, '0');
        const newsDate = `${y}-${m}-${d}`;
        this.setState({ newsDate }, () => this.loadLatest());
    };

    openArticle = (article) => {
        try {
            sessionStorage.setItem(NEWS_ARTICLE_STORAGE, JSON.stringify(article));
        } catch (e) {
            /* ignore quota / private mode */
        }
        const { history, match } = this.props;
        const uid = getUid();
        history.push({
            pathname: `${match.url}/detail`,
            search: uid ? `?uid=${uid}` : '',
            state: { article },
        });
    };

    renderArticle = (a, i) => {
        const key = a.id || a.url || String(i);
        return (
            <article
                key={key}
                className="news-card-grid news-card-match-style news-card-clickable"
                role="button"
                tabIndex={0}
                onClick={() => this.openArticle(a)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.openArticle(a);
                    }
                }}
            >
                <div className="news-card-grid-media">
                    {a.urlToImage ? (
                        <img src={a.urlToImage} alt="" loading="lazy" />
                    ) : (
                        <div className="news-card-grid-placeholder" aria-hidden />
                    )}
                </div>
                <div className="news-card-grid-body">
                    {a.source ? <span className="news-card-grid-meta">{a.source}</span> : null}
                    <span className="news-card-grid-title news-card-grid-title--link">{a.title}</span>
                    {a.description ? <p className="news-card-grid-desc">{a.description}</p> : null}
                    {a.publishedAt ? (
                        <time className="news-card-grid-time">{a.publishedAt}</time>
                    ) : null}
                </div>
            </article>
        );
    };

    renderSkeletonCards = () => {
        const placeholders = Array.from({ length: 8 });
        return placeholders.map((_, i) => (
            <article key={`news-skeleton-${i}`} className="news-card-grid news-card-skeleton" aria-hidden>
                <div className="news-card-grid-media news-skeleton-block" />
                <div className="news-card-grid-body">
                    <span className="news-skeleton-line news-skeleton-line--meta" />
                    <span className="news-skeleton-line news-skeleton-line--title" />
                    <span className="news-skeleton-line news-skeleton-line--title short" />
                    <span className="news-skeleton-line news-skeleton-line--desc" />
                    <span className="news-skeleton-line news-skeleton-line--desc short" />
                </div>
            </article>
        ));
    };

    renderVideoCard = (v, i) => {
        const { intl } = this.props;
        const key = v.id || v.matchviewUrl || String(i);
        const teams = [v.side1 && v.side1.name, v.side2 && v.side2.name].filter(Boolean).join(' vs ');
        return (
            <article key={key} className="news-card-grid news-card-match-style">
                <div className="news-video-frame-wrap">
                    {v.thumbnail ? (
                        <img src={v.thumbnail} alt={v.title || teams || 'video thumbnail'} loading="lazy" />
                    ) : (
                        <div className="news-card-grid-placeholder" aria-hidden />
                    )}
                    <button
                        type="button"
                        className="news-video-play-btn"
                        onClick={() => this.setState({ activeVideo: v })}
                        disabled={!v.embedUrl}
                        aria-label={intl.formatMessage({ id: 'news_video_play', defaultMessage: 'Play video' })}
                    >
                        <span className="news-video-play-icon" aria-hidden>
                            &#9658;
                        </span>
                    </button>
                </div>
                <div className="news-card-grid-body">
                    {v.competition ? <span className="news-card-grid-meta">{v.competition}</span> : null}
                    <span className="news-card-grid-title">{v.title || teams}</span>
                    {v.date ? <time className="news-card-grid-time">{v.date}</time> : null}
                </div>
            </article>
        );
    };

    render() {
        const {
            tab,
            leagues,
            teams,
            leagueId,
            teamId,
            newsDate,
            articles,
            videos,
            activeVideo,
            loading,
            loadingVideos,
            loadingLeagues,
            loadingTeams,
            configured,
            message,
            error,
            videosError,
        } = this.state;
        const { selectedLanguage, intl } = this.props;
        const rtl = selectedLanguage === 'ar';
        const activeLogo = getDomainLogo();

        return (
            <div className={rtl ? 'news-page news-page-rtl' : 'news-page'}>
                <div className="news-shell">
                    <div className="news-panel">
                        <nav className="news-tabs" role="tablist" aria-label="News sections">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={tab === 'latest'}
                                className={`news-tab ${tab === 'latest' ? 'is-active' : ''}`}
                                onClick={() => this.setTab('latest')}
                            >
                                <FormattedMessage id="news_tab_latest" defaultMessage="Latest" />
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={tab === 'videos'}
                                className={`news-tab ${tab === 'videos' ? 'is-active' : ''}`}
                                onClick={() => this.setTab('videos')}
                            >
                                <FormattedMessage id="news_tab_videos" defaultMessage="Videos" />
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={tab === 'league'}
                                className={`news-tab ${tab === 'league' ? 'is-active' : ''}`}
                                onClick={() => this.setTab('league')}
                            >
                                <FormattedMessage id="news_tab_league" defaultMessage="By league" />
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={tab === 'team'}
                                className={`news-tab ${tab === 'team' ? 'is-active' : ''}`}
                                onClick={() => this.setTab('team')}
                            >
                                <FormattedMessage id="news_tab_team" defaultMessage="By team" />
                            </button>
                        </nav>

                        {tab === 'latest' && (
                            <div className="news-cal-header" role="region" aria-label="Latest news filters">
                                <div>
                                    <span className="news-panel-head">
                                        <FormattedMessage id="news_latest_head" defaultMessage="Latest headlines" />
                                    </span>
                                    <span className="news-panel-subhead">
                                        {selectedLanguage === 'fr'
                                            ? formateDate(newsDate, 'DD MMMM,YYYY')
                                            : formateDate(newsDate, 'dddd, MMMM Do')}
                                    </span>
                                </div>
                                <div className="news-match-date-picker">
                                    <DatePicker
                                        disabledDays={{ after: new Date() }}
                                        locale={selectedLanguage}
                                        highlightedDate={newsDate}
                                        getSelectedDate={this.onNewsDatePicked}
                                        title={
                                            <FormattedMessage
                                                id="calendar-dropdown-title"
                                                defaultMessage="Select a date"
                                            />
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        {tab === 'league' && (
                            <div className="news-cal-header news-cal-header--filters">
                                <div>
                                    <span className="news-panel-head">
                                        <FormattedMessage id="news_tab_league" defaultMessage="By league" />
                                    </span>
                                    <span className="news-panel-subhead">
                                        <FormattedMessage
                                            id="news_league_sub"
                                            defaultMessage="Pick a competition to load stories"
                                        />
                                    </span>
                                </div>
                            </div>
                        )}

                        {tab === 'videos' && (
                            <div className="news-cal-header news-cal-header--filters">
                                <div>
                                    <span className="news-panel-head">
                                        <FormattedMessage id="news_tab_videos" defaultMessage="Videos" />
                                    </span>
                                    <span className="news-panel-subhead">
                                        <FormattedMessage
                                            id="news_videos_sub"
                                            defaultMessage="Latest football highlights powered by Scorebat"
                                        />
                                    </span>
                                </div>
                            </div>
                        )}

                        {tab === 'team' && (
                            <div className="news-cal-header news-cal-header--filters">
                                <div>
                                    <span className="news-panel-head">
                                        <FormattedMessage id="news_tab_team" defaultMessage="By team" />
                                    </span>
                                    <span className="news-panel-subhead">
                                        <FormattedMessage
                                            id="news_team_sub"
                                            defaultMessage="Choose a league, then a club"
                                        />
                                    </span>
                                </div>
                            </div>
                        )}

                        {tab === 'league' && (
                            <div className="news-toolbar">
                                <label className="news-field news-field-grow">
                                    <span className="news-field-label">
                                        <FormattedMessage id="news_filter_league" defaultMessage="League" />
                                    </span>
                                    <select
                                        className="news-select"
                                        value={leagueId}
                                        onChange={this.onLeagueChangeLeagueTab}
                                        disabled={loadingLeagues}
                                    >
                                        <option value="">
                                            {intl.formatMessage({
                                                id: 'news_select_league',
                                                defaultMessage: 'Choose a league',
                                            })}
                                        </option>
                                        {leagues.map((l) => (
                                            <option key={l.id} value={l.id}>
                                                {l.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        )}

                        {tab === 'team' && (
                            <div className="news-toolbar news-toolbar-split">
                                <label className="news-field news-field-grow">
                                    <span className="news-field-label">
                                        <FormattedMessage id="news_filter_league" defaultMessage="League" />
                                    </span>
                                    <select
                                        className="news-select"
                                        value={leagueId}
                                        onChange={this.onLeagueChangeTeamTab}
                                        disabled={loadingLeagues}
                                    >
                                        <option value="">
                                            {intl.formatMessage({
                                                id: 'news_select_league',
                                                defaultMessage: 'Choose a league',
                                            })}
                                        </option>
                                        {leagues.map((l) => (
                                            <option key={l.id} value={l.id}>
                                                {l.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                                <label className="news-field news-field-grow">
                                    <span className="news-field-label">
                                        <FormattedMessage id="news_filter_team" defaultMessage="Team" />
                                    </span>
                                    <select
                                        className="news-select"
                                        value={teamId}
                                        onChange={this.onTeamChange}
                                        disabled={!leagueId || loadingTeams}
                                    >
                                        <option value="">
                                            {leagueId
                                                ? intl.formatMessage({
                                                      id: 'news_select_team',
                                                      defaultMessage: 'Choose a team',
                                                  })
                                                : intl.formatMessage({
                                                      id: 'news_select_league_first',
                                                      defaultMessage: 'Pick a league to see clubs',
                                                  })}
                                        </option>
                                        {teams.map((t) => (
                                            <option key={t.id} value={t.id}>
                                                {t.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        )}

                    <div className="news-controls">

                    {!loading && !configured && (
                        <p className="news-status news-hint">
                            <FormattedMessage
                                id="news_config_hint"
                                defaultMessage="Configure the football news API key on the server to show headlines."
                            />
                        </p>
                    )}

                    {!loading && configured && message && !articles.length && (
                        <p className="news-status">{message}</p>
                    )}

                    {!loading && error && (
                        <p className="news-status news-error">
                            <FormattedMessage id="news_error" defaultMessage="Could not load news. Try again later." />
                        </p>
                    )}
                    {!loadingVideos && videosError && tab === 'videos' && (
                        <p className="news-status news-error">
                            <FormattedMessage id="news_videos_error" defaultMessage="Could not load videos. Try again later." />
                        </p>
                    )}

                    {!loading &&
                        articles.length === 0 &&
                        configured &&
                        !error &&
                        !message &&
                        tab === 'latest' && (
                            <p className="news-status">
                                <FormattedMessage id="news_empty" defaultMessage="No headlines right now." />
                            </p>
                        )}

                    {!loading &&
                        articles.length === 0 &&
                        configured &&
                        !error &&
                        tab === 'league' &&
                        !message && (
                            <p className="news-status news-muted">
                                {leagueId ? (
                                    <FormattedMessage
                                        id="news_empty_league"
                                        defaultMessage="No headlines for this league right now."
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="news_select_league"
                                        defaultMessage="Choose a league"
                                    />
                                )}
                            </p>
                        )}

                    {!loading &&
                        articles.length === 0 &&
                        configured &&
                        !error &&
                        tab === 'team' &&
                        !message && (
                            <p className="news-status news-muted">
                                {teamId ? (
                                    <FormattedMessage
                                        id="news_empty_team"
                                        defaultMessage="No headlines for this club right now."
                                    />
                                ) : leagueId ? (
                                    <FormattedMessage
                                        id="news_select_team"
                                        defaultMessage="Choose a team"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="news_select_league_first"
                                        defaultMessage="Pick a league to see clubs"
                                    />
                                )}
                            </p>
                        )}
                    {!loadingVideos &&
                        videos.length === 0 &&
                        configured &&
                        !videosError &&
                        tab === 'videos' &&
                        !message && (
                            <p className="news-status">
                                <FormattedMessage id="news_videos_empty" defaultMessage="No videos available right now." />
                            </p>
                        )}
                    </div>

                    <div className="news-grid-scroll">
                        {tab !== 'videos' && loading && <div className="news-grid news-grid-skeleton">{this.renderSkeletonCards()}</div>}
                        {tab !== 'videos' && !loading && articles.length > 0 && (
                            <div className="news-grid">{articles.map(this.renderArticle)}</div>
                        )}
                        {tab === 'videos' && loadingVideos && (
                            <div className="news-grid news-grid-skeleton">{this.renderSkeletonCards()}</div>
                        )}
                        {tab === 'videos' && !loadingVideos && videos.length > 0 && (
                            <div className="news-grid">{videos.map(this.renderVideoCard)}</div>
                        )}
                        {articles.length > 0 && (
                            <p className="news-attribution">
                                <FormattedMessage
                                    id="news_powered_by"
                                    defaultMessage="Football News 11"
                                />
                            </p>
                        )}
                        {videos.length > 0 && tab === 'videos' && (
                            <p className="news-attribution">
                                <FormattedMessage id="news_videos_powered_by" defaultMessage="Scorebat" />
                            </p>
                        )}
                    </div>
                    </div>
                </div>
                {activeVideo && (
                    <div
                        className="news-video-modal-backdrop"
                        role="presentation"
                        onClick={() => this.setState({ activeVideo: null })}
                    >
                        <div
                            className="news-video-modal"
                            role="dialog"
                            aria-modal="true"
                            aria-label={activeVideo.title || 'Video player'}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="news-video-modal-header">
                                <span className="news-video-modal-title">
                                    {activeVideo.title ||
                                        [
                                            activeVideo.side1 && activeVideo.side1.name,
                                            activeVideo.side2 && activeVideo.side2.name,
                                        ]
                                            .filter(Boolean)
                                            .join(' vs ')}
                                </span>
                                <button
                                    type="button"
                                    className="news-video-modal-close"
                                    onClick={() => this.setState({ activeVideo: null })}
                                    aria-label={intl.formatMessage({
                                        id: 'news_video_close',
                                        defaultMessage: 'Close',
                                    })}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="news-video-modal-stage">
                                <iframe
                                    title={activeVideo.title || 'video-player'}
                                    src={activeVideo.embedUrl}
                                    className="news-video-modal-frame"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                />
                                <span className="news-video-modal-cover news-video-modal-cover--yt" aria-hidden>
                                    <img src={activeLogo} alt="" className="news-video-modal-cover-logo" />
                                </span>
                                <span className="news-video-modal-cover news-video-modal-cover--fs" aria-hidden />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedLanguage: state.HeaderReducer.selectedLanguage,
});

const ConnectedNewsList = connect(mapStateToProps, null)(injectIntl(withRouter(NewsList)));

/** Nested routes: list at /news, article reader at /news/detail */
function News(props) {
    const { match } = props;
    return (
        <Switch>
            <Route path={`${match.path}/detail`} component={NewsDetail} />
            <Route exact path={match.path} component={ConnectedNewsList} />
        </Switch>
    );
}

export default News;
